import WarningButton from './WarningButton.js';

export default WarningButton;
